import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

const useStore = create(
  subscribeWithSelector((set, get) => ({
    // NAVIGATION

    uid: null,
    setUid: (uid) => set({ uid }),
    url: process.env.REACT_APP_URL,

    lang: "de",
    availableLanguages: [],

    setLang: (lang) => {
      const newLang = get().availableLanguages.find((l) => l.code === lang);
      console.log("Set Lang", lang, newLang, get().availableLanguages);

      set({ lang: newLang.code });
      get().fetchAll();
    },

    isHost: false,
    setHost: (isHost) => set({ isHost }),

    menuOpen: false,
    toggleMenu: () => set({ menuOpen: !get().menuOpen }),
    setMenuOpen: (menuOpen) => set({ menuOpen }),

    fetchLanguages: async () => {
      fetch(`${process.env.REACT_APP_API_URL}/i18n/locales`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Locales", data);

          set({ availableLanguages: data });
        })
        .catch((error) => console.error(error));
    },

    fetchAll: async () => {
      get().fetchTexts();
      get().fetchRules();
      get().fetchSession(get().uid);
    },

    // FETCH TEXTS
    texts: null,
    defaultTexts: null,
    fetchTexts: async () => {
      fetch(
        `${process.env.REACT_APP_API_URL}/default-text?locale=${
          //get().lang
          "all"
        }&populate=*`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("Texts", data);
          const localeTexts =
            data?.data?.find((t) => t.attributes.locale === get().lang) ??
            data?.data?.[0];

          set({
            texts: localeTexts?.attributes,
            defaultTexts: data?.data?.find((t) => t.attributes.locale === "de")
              .attributes,
          });
        })
        .catch((error) => console.error(error));
    },

    // FETCH RULES
    rules: null,
    defaultRules: null,
    fetchRules: async () => {
      console.log("Fetch Rules", get().lang, get().game?.spielregeln?.data?.id);

      fetch(
        `${process.env.REACT_APP_API_URL}/spielregelns/${
          get().game?.spielregeln?.data?.id
        }?locale=${
          //get().lang
          "all"
        }&populate[fields]=*&populate[Regeln][populate]=*&populate[Regeln][fields]=*&populate[localizations][fields]=*`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("Rules", data.data);

          // const localeRules =
          //   data?.find((r) => r.attributes.locale === get().lang) ?? data;
          set({
            rules: data?.data?.attributes,
            defaultRules: data?.data?.attributes,
          });
        })
        .catch((error) => console.error(error));
    },
    // FETCH SESSION
    sessionID: -1,
    sessionNotFound: false,
    fetchSession: async (uid) => {
      const queryParameters = new URLSearchParams(window.location.search);
      const host = queryParameters.get("host");

      fetch(
        `${process.env.REACT_APP_API_URL}/sessions?filters[uid][$eq]=${uid}&populate=*`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("Set fetched Session", data);
          if (data.data && data.data.length > 0) {
            console.log("Host", data.data[0].attributes.hostid, host);
            set({
              sessionID: data.data[0].id,
              sessionData: data.data[0].attributes,
              gameState: data.data[0].attributes.gameState,
              isHost: data.data[0].attributes.hostid === host,
              currentHint: data.data[0].attributes.HintOpened,
              sessionNotFound: false,
            });
            return data.data[0].attributes.gameid;
          } else {
            set({ sessionNotFound: true });
            return null;
          }
        })
        .then((gameid) => {
          const res = fetch(
            `${
              process.env.REACT_APP_API_URL
            }/games?filters[id][$eq]=${gameid}&populate[fields]=*&populate[Menue][populate]=*&populate[Downloads][populate][File]=true&populate[Characters][populate]=*&populate[Hints][fields]=*&populate[Hints][populate][Character]=true&populate[Hints][populate][HintMedium]=true&populate[Intro][populate][Audio]=*&populate[Aufloesung][populate][Audio]=*&populate[Spielablauf][populate][Audio]=*&populate[spielregeln][fields]=id&populate[ZusatzInfoBilder][populate][Bild]=*&locale=${
              //get().lang
              "all"
            }`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
              },
            }
          );
          return res;
        })
        .then((response) => response.json())
        .then((data) => {
          console.log("Game:", data);
          const localeGame =
            data?.data?.find((g) => g.attributes.locale === get().lang) ??
            data?.data?.[0];
          set({
            game: localeGame?.attributes,
            defaultGame: data?.data?.find((t) => t.attributes.locale === "de")
              .attributes,
          });
        })
        .catch((error) => console.error(error));
    },
    sessionData: null,
    setSessionData: (sessionID, sessionData) => {
      console.log("SessionData", sessionData, sessionData.state);

      set({
        sessionID,
        sessionData,
        gameState: sessionData.gameState,
      });
    },
    game: null,
    defaultGame: null,
    setGame: (game) => {
      set({ game });
    },

    getLocalized: (type, key) => {
      const camelCaseType = type.charAt(0).toUpperCase() + type.slice(1);
      if (!get()[type][key] == null)
        return get()["default" + camelCaseType][key];
      return get()[type][key] ?? get()["default" + camelCaseType][key];
    },

    gameState: -1,
    setGameState: (gameState) => {
      if (gameState >= -1 && gameState <= get().game.Rounds) {
        console.log("setGameState", gameState, get().sessionData);
        set({ gameState });
      }

      const data = {
        data: {
          gameState: gameState,
        },
      };

      if (gameState === 0) {
        const startTime = new Date();

        data.data.started = true;
        data.data.timeStarted = startTime;
      }

      const res = fetch(
        `${process.env.REACT_APP_API_URL}/sessions/${get().sessionID}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );
    },

    // startGameSession: () => {
    //   const startTime = new Date();
    //   const data = {
    //     data: {
    //       started: true,
    //       timeStarted: startTime,
    //     },
    //   };

    //   const res = fetch(
    //     `${process.env.REACT_APP_API_URL}/sessions/${get().sessionID}`,
    //     {
    //       method: "PUT",
    //       headers: {
    //         Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
    //       },
    //       body: JSON.stringify(data),
    //     }
    //   );
    // },

    // API CALLS
    // CHARACTER CHECKIN
    checkinCharacter: async (character, check, ishost) => {
      console.log("Checkin Character", character, check, ishost);

      const data = {
        data: {
          CharacterLogin: [
            {
              __component: "gamestate.character-check",
              characterid: character.id,
              check: check,
            },
          ],
        },
      };

      if (ishost) {
        //set({ character: character });
        if (check) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set("c", character.uid);
          window.history.pushState({}, "", currentUrl);
        }
        data.data.hostcharacteruid = check ? character.uid : null;
      }

      const res = fetch(
        `${process.env.REACT_APP_API_URL}/sessions/${get().sessionID}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      ).then((response) => {
        console.log("Checkin Character Response", response);
      });
    },
    // Check if Role is taken:

    checkRole: (character) => {
      // Handle both full character objects and just IDs
      // When coming from game.Characters.data, structure is: { id: X, attributes: { id: Y } }
      // We need attributes.id (Y) to match with CharacterLogin.characterid
      let charId;
      if (typeof character === "object") {
        // Check if it's the full structure with attributes
        charId = character.attributes?.id || character.id;
      } else {
        charId = character;
      }

      console.log("Checkrole", {
        inputCharacter: character,
        resolvedCharId: charId,
        characterLogins: get().sessionData?.CharacterLogin,
      });

      const loginEntry = get().sessionData?.CharacterLogin?.find(
        (c) => c.characterid === charId
      );

      const taken = loginEntry?.check;
      console.log("Check Role Result", { charId, loginEntry, taken });
      return taken;
    },

    allCharactersCheckedIn: false,
    // Check if all characters are checked in
    checkAllCharactersCheckedIn: () => {
      // Check if game and characters data exists
      if (!get().game?.Characters?.data) {
        console.log("No game or characters data available");
        set({ allCharactersCheckedIn: false });
        return;
      }

      const allCheckedIn = get().game.Characters.data.every((c) => {
        // If it's a main character (Hauptcharakter), check if it's checked in
        if (c?.attributes?.Hauptcharakter) {
          const isCheckedIn = get().checkRole(c);
          console.log(
            `Character ${c.attributes?.Name || "Unknown"} (ID: ${
              c.id
            }): Hauptcharakter=${
              c.attributes.Hauptcharakter
            }, CheckedIn=${isCheckedIn}`
          );
          return !!isCheckedIn; // Convert to boolean to handle undefined
        }
        // If it's not a main character, don't require check-in
        return true;
      });

      console.log("Check All Characters Checked In", {
        totalCharacters: get().game.Characters.data.length,
        allCheckedIn,
        characterLogins: get().sessionData?.CharacterLogin,
      });
      set({ allCharactersCheckedIn: allCheckedIn });
    },

    character: null,
    defaultCharacter: null,
    //setCharacter: (character) => set({ character }),

    fetchCharacter: async (id) => {
      fetch(
        `${
          process.env.REACT_APP_API_URL
        }/characters?filters[id][$eq]=${id}&locale=${
          //get().lang
          "all"
        }&populate[fields]=*&populate[Verkleidung][populate][media]=true&populate[Times][fields]=*&populate[Profilbild]=*`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log("Character", data.data[0]);
          const localeCharacter =
            data?.data?.find((c) => c.attributes.locale === get().lang) ??
            data?.data?.[0];

          const defaultCharacter = data.data.find(
            (t) => t.attributes.locale === "de"
          );
          localeCharacter.attributes.id = defaultCharacter.id;
          defaultCharacter.attributes.id = defaultCharacter.id;

          set({
            character: localeCharacter?.attributes,
            defaultCharacter: defaultCharacter?.attributes,
          });
        })
        .catch((error) => console.error(error));
    },

    // hint: null,
    currentHint: -1,
    /*openHint: (hint) => {
      set({ hint });
    },
    closeHint: () => {
      set({ hint: null });
    }, */

    revealNextHint: () => {
      let newHint = get().currentHint + 1;
      if (get().game.Hints.length > newHint) {
        set({ currentHint: newHint });
      }
      get().setSessionHint(newHint);
    },

    setSessionHint: (hint) => {
      console.log("setSessionHint", hint);
      const data = {
        data: {
          HintOpened: hint,
        },
      };
      const res = fetch(
        `${process.env.REACT_APP_API_URL}/sessions/${get().sessionID}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );
    },

    showHintTooltip: false,
    activateHintTooltip: (hint) => {
      console.log(
        "Activate Hint Tooltip",
        hint,
        get().game?.Hints?.[hint]?.Character?.data?.id,
        get().character?.id
      );
      if (
        get().character?.id === get().game?.Hints?.[hint]?.Character?.data?.id
      )
        return;

      set({ showHintTooltip: true });
      setTimeout(() => set({ showHintTooltip: false }), 5000);
    },

    // POPUP BILD
    popupBildOpen: false,
    currentPopupBild: null,
    hasPopupBild: false,
    setHasPopupBild: (hasPopupBild) => set({ hasPopupBild }),
    openPopupBild: (popupBild) => {
      set({ popupBildOpen: true, currentPopupBild: popupBild });
    },
    closePopupBild: () => {
      set({ popupBildOpen: false, currentPopupBild: null });
    },
  }))
);

export default useStore;
